import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.svg";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import { Logout } from "../../services/AuthService";
import { useTranslation } from "react-i18next";
import CartService from "../../services/CartService";
import cartImg from "../../assets/cart.svg";
import searchIcon from "../../assets/search.svg";
import kuwait from "../../assets/kuwait.svg";
import usa from "../../assets/usa.svg";
import { motion } from "framer-motion";
import "./style.css";
import { setSearchState } from "../../store/actions/AuthActions";
import { changeLang } from "../../store/actions/LangActions";

const Navbar = () => {
	const [open, setOpen] = useState(false);
	const [cart, setCart] = useState(0);
	const [isHome, setIsHome] = useState(false);
	const [showSearch, setShowSearch] = useState(false);
	const [search, setSearch] = useState("");
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const user = useSelector((state) => state.user);
	const lang = useSelector((state) => state.lang.lang);
	const { t } = useTranslation();
	const { i18n } = useTranslation();

	useEffect(() => {
		let pathname = location.pathname.slice(1);
		if (!pathname) {
			setIsHome(true);
		} else {
			setIsHome(false);
		}
	}, [location]);

	useEffect(() => {
		if (!!user?.user) {
			new CartService()
				.getList()
				.then((res) => {
					if (res?.status === 200) {
						setCart(res.data?.data?.sub_carts?.length);
					}
					return;
				})
				.catch((e) => {
					if (e?.response?.data?.message === "cart_not_Exist") {
						setCart(user?.cart?.length);
					}
				});
		} else {
			setCart(user?.cart?.length);
		}
	}, [user, user?.user, user?.cart]);

	const closeNavbar = () => {
		const navbar = document.querySelector(".navbar-collapse");
		if (navbar.classList.contains("show")) {
			// new window.bootstrap.Collapse(navbar).hide(); // requires Bootstrap JS
			navbar.classList.remove("show");
		}
		setOpen(false);
	};

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		dispatch(changeLang(lng));
	};

	return (
		<nav
			className={`navbar navbar-expand-lg ${
				isHome ? "navbar-home" : "navbar-pages"
			}`}>
			<div className="row w-100 m-auto" style={{ alignItems: "center" }}>
				<div className="col-lg-2 col-5 one nav-logo">
					<Link to="/" className="navbar-brand logo m-0 p-0">
						<motion.img
							src={logo}
							alt="logo"
							width={135}
							height={50}
							initial={{ opacity: 0, x: -50 }}
							animate={{ opacity: 1, x: 0 }}
							transition={{ duration: 1 }}
						/>
					</Link>
				</div>

				<div className="col-lg-6 two col-1">
					<button
						className={`navbar-toggler hamburger ${open ? "open" : ""}`}
						type="button"
						onClick={() => setOpen((prev) => !prev)}
						data-bs-toggle="collapse"
						data-bs-target="#navbarNavAltMarkup"
						aria-controls="navbarNavAltMarkup"
						aria-expanded="false"
						aria-label="Toggle navigation">
						<span></span>
						<span></span>
						<span></span>
					</button>
					<div
						className="collapse navbar-collapse"
						style={{ width: "fit-content" }}
						id="navbarNavAltMarkup">
						<div className="navbar-nav">
							<NavLink
								to="/"
								onClick={closeNavbar}
								className={({ isActive }) =>
									isActive ? "active nav-link" : "nav-link"
								}
								aria-current="page">
								{t("home")}
							</NavLink>
							<NavLink
								to="/our-products"
								onClick={closeNavbar}
								className={() =>
									location.pathname === "/categories" ||
									location.pathname === "/products" ||
									location.pathname === "/best-seller" ||
									location.pathname.startsWith("/category") ||
									location.pathname === "/our-products"
										? "active nav-link"
										: "nav-link"
								}
								aria-current="page">
								{t("Our products")}
							</NavLink>
							<NavLink
								to="/about-us"
								onClick={closeNavbar}
								className={({ isActive }) =>
									isActive ? "active nav-link" : "nav-link"
								}
								aria-current="page">
								{t("about-us")}
							</NavLink>
							<div className="web">
								{!!user?.user ? (
									<Dropdown className="profile-dropdown">
										<Dropdown.Toggle
											id="dropdown-basic"
											className="nav-link p-0"
											style={{
												background: "none",
												border: "none",
												paddingRight: "0",
												color:
													location?.pathname === "/profile"
														? "var(--primary-color)"
														: "#000",
											}}>
											<span className="web mb-0 tablet">
												{user?.user?.username?.slice(0, 8)}
											</span>
											<span className="mobile mobile-profile">
												{user?.user?.username?.slice(0, 1)}
											</span>
										</Dropdown.Toggle>

										<Dropdown.Menu>
											<Dropdown.Item
												className="text-primary"
												onClick={() => navigate("/profile")}>
												{t("Profile")}
											</Dropdown.Item>
											<Dropdown.Item
												className="text-danger"
												onClick={() =>
													Logout(
														user?.accessToken,
														dispatch,
														navigate,
														location?.pathname
													)
												}>
												{t("Logout")}
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								) : (
									<div>
										<NavLink
											to="/login"
											state={{ path: location.pathname }}
											onClick={closeNavbar}
											className="nav-link"
											aria-current="page">
											<span className="text-wrap mb-0">{t("my account")}</span>
										</NavLink>
									</div>
								)}
							</div>
							<div className="tablet mt-3 m-auto">
								<button
									onClick={() => changeLanguage(lang === "en" ? "ar" : "en")}
									className={`nav-link language ${lang}`}>
									<span className={lang === "en" ? "ar" : "en"}>
										{lang !== "ar" ? "العربية" : "English"}
									</span>
									{lang !== "ar" ? (
										<img src={kuwait} alt="kuwait" width={40} />
									) : (
										<img src={usa} alt="usa" width={40} />
									)}
								</button>
							</div>
							{/* <div className="table mobile">
									<div className="search-input">
										<input value={search} placeholder={t("search")} />
										<div className="search-icons">
											<span
												onClick={() => {
													setSearch("");
													setShowSearch(false);
												}}>
												x
											</span>
											<img
												src={searchIcon}
												alt="searchIcon"
												className="p-0"
												width={32}
											/>
										</div>
									</div>
								</div> */}
						</div>
					</div>
				</div>

				<div
					className="col-lg-4 three col-6 d-flex align-items-center"
					style={{
						justifyContent: "end",
						gap: showSearch ? "32px" : "auto",
					}}>
					<div className={showSearch ? "w-100" : ""}>
						{!showSearch && (
							<img
								src={searchIcon}
								alt="searchIcon"
								onClick={() => setShowSearch(true)}
								width={32}
								className="cursor-pointer"
								height={32}
							/>
						)}
						{showSearch && (
							<div className="search-input">
								<input
									value={search}
									placeholder={t("search")}
									onChange={(e) => setSearch(e.target.value)}
									onKeyDown={(e) => {
										if (e.key === "Enter") {
											dispatch(setSearchState(search));
											if (!!search) navigate("/products");
										}
									}}
								/>
								<span
									onClick={() => {
										setSearch("");
										dispatch(setSearchState(""));
										setShowSearch(false);
									}}>
									x
								</span>
							</div>
						)}
					</div>

					{!showSearch && (
						<Link
							to="/cart"
							className="nav-link p-0 d-flex cart-icon position-relative"
							style={{ alignItems: "center" }}>
							<img src={cartImg} alt="cartImg" className="cartImg" />
							{cart > 0 && <p className="cart-num"></p>}
						</Link>
					)}
					{!showSearch && (
						<div className="tablet mobile login-icon-sec">
							{!!user?.user ? (
								<Dropdown className="profile-dropdown">
									<Dropdown.Toggle
										id="dropdown-basic"
										className="nav-link p-0"
										style={{
											background: "none",
											border: "none",
											paddingRight: "0",
											color:
												location?.pathname === "/profile"
													? "var(--primary-color)"
													: "#000",
										}}>
										<span className="web mb-0 tablet">
											{user?.user?.username?.slice(0, 8)}
										</span>
										<span className="mobile mobile-profile">
											{user?.user?.username?.slice(0, 1)}
										</span>
									</Dropdown.Toggle>

									<Dropdown.Menu>
										<Dropdown.Item
											className="text-primary"
											onClick={() => navigate("/profile")}>
											{t("Profile")}
										</Dropdown.Item>
										<Dropdown.Item
											className="text-danger"
											onClick={() =>
												Logout(
													user?.accessToken,
													dispatch,
													navigate,
													location?.pathname
												)
											}>
											{t("Logout")}
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							) : (
								<NavLink
									to="/login"
									state={{ path: location.pathname }}
									className="nav-link"
									aria-current="page">
									<svg
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										stroke="#209b99">
										<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
										<g
											id="SVGRepo_tracerCarrier"
											strokeLinecap="round"
											strokeLinejoin="round"></g>
										<g id="SVGRepo_iconCarrier">
											{" "}
											<circle
												opacity="0.5"
												cx="12"
												cy="9"
												r="3"
												stroke="#000"
												strokeWidth="1.5"></circle>{" "}
											<circle
												cx="12"
												cy="12"
												r="10"
												stroke="#000"
												strokeWidth="1.5"></circle>{" "}
											<path
												opacity="0.5"
												d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20"
												stroke="#000"
												strokeWidth="1.5"
												strokeLinecap="round"></path>{" "}
										</g>
									</svg>
								</NavLink>
							)}
						</div>
					)}
					<div className="web">
						<button
							onClick={() => changeLanguage(lang === "en" ? "ar" : "en")}
							className={`nav-link language ${lang}`}>
							<span className={lang === "en" ? "ar" : "en"}>
								{lang !== "ar" ? "العربية" : "English"}
							</span>
							{lang !== "ar" ? (
								<img src={kuwait} alt="kuwait" width={40} />
							) : (
								<img src={usa} alt="usa" width={40} />
							)}
						</button>
					</div>
				</div>
			</div>
		</nav>
	);
};
export default Navbar;
